var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXls = function SvgXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#xls_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 15,
    y: 24,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 24,
    y: 24,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 33,
    y: 24,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 15,
    y: 30,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 24,
    y: 30,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 33,
    y: 30,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 15,
    y: 36,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 24,
    y: 36,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    x: 33,
    y: 36,
    fill: "#C0BEBE",
    rx: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#13B567",
    rx: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.633 12 .984 1.746h.047L11.66 12h1.817l-1.793 3 1.863 3h-1.863l-1.02-1.781h-.047L9.597 18h-1.85l1.839-3-1.781-3zm4.546 6v-6h1.629v4.688h2.426V18zm7.948-4.125a.63.63 0 0 0-.22-.457q-.195-.164-.59-.164-.251 0-.412.061a.5.5 0 0 0-.235.162.4.4 0 0 0-.079.234.4.4 0 0 0 .038.196q.047.086.147.155.099.068.255.123.154.056.369.1l.492.106q.498.105.853.278.355.172.58.407.225.231.33.522.11.29.112.632-.003.593-.296 1.002-.292.411-.838.624-.542.214-1.303.214-.783 0-1.366-.231a1.9 1.9 0 0 1-.902-.712q-.32-.483-.322-1.236h1.547q.015.275.137.463.124.188.346.284.226.096.536.096.261 0 .437-.064a.6.6 0 0 0 .266-.179.42.42 0 0 0 .094-.26.37.37 0 0 0-.09-.24.7.7 0 0 0-.282-.188 3 3 0 0 0-.53-.159l-.598-.128q-.797-.174-1.257-.578-.457-.406-.454-1.11-.003-.57.305-.999.31-.43.858-.67a3.1 3.1 0 0 1 1.263-.241q.726 0 1.257.243t.817.686q.29.439.293 1.028z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xls_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgXls;